import { defineMessages } from 'react-intl';

export const lastModifiedFilterMessages = defineMessages({
  all: {
    id: 'patientList.lastModified.all',
    defaultMessage: 'All',
  },
  today: {
    id: 'patientList.lastModified.today',
    defaultMessage: 'Today',
  },
  oneWeek: {
    id: 'patientList.lastModified.oneWeek',
    defaultMessage: 'One Week',
  },
  custom: {
    id: 'patientList.lastModified.custom',
    defaultMessage: 'Custom',
  },
  from: {
    id: 'global.from',
    defaultMessage: 'From',
  },
  to: {
    id: 'global.to',
    defaultMessage: 'To',
  },
});
